"use strict";

import './css_load';
import '@splidejs/splide/src/css/template/default/index.scss';
import "../scss/style.scss";
import './map/_index';
import './scrollTop/_index';
import './scrollAnimation/_index';
import './accordion/_index';
import './splide/_index';
import './headerMenu/_index';
import './firstAnimation/_index';
import './gsap/_index';
import './blocks/_medias-front';
import './hover/_index';
// import './vivus/_index';
import './style/_index';
import './anker/_index';

window.addEventListener('load', () => {
})

document.addEventListener('DOMContentLoaded', function () {
    var div = document.querySelector('.js-contact-form-wrap');
    if (div) {
        // 新しいlabelタグを作成
        var label = document.createElement('label');

        // 元のdivの属性をコピー
        for (var i = 0; i < div.attributes.length; i++) {
            var attr = div.attributes[i];
            label.setAttribute(attr.name, attr.value);
        }

        // 子要素をコピー
        while (div.firstChild) {
            label.appendChild(div.firstChild);
        }

        // 元のdivをlabelに置き換え
        div.parentNode.replaceChild(label, div);
    }
});

// 角度を度からラジアンに変換する関数
function degToRad(deg) {
    return deg * Math.PI / 180;
}

// project処理
function ClipPath() {
    const targets = document.querySelectorAll('.js-clip-path');
    const isSmallScreen = window.innerWidth <= 1024; // 画面幅の判定
    const angleDeg = isSmallScreen ? 2.5 : 10; // 回転角 10°
    const angleRad = degToRad(angleDeg);    // ラジアンに変換
    
    console.log(window);

    if (targets.length) {
        Array.from(targets).forEach((target, index) => {
            const posValue = target.dataset.pos;
            let setPos = {
                'leftTop': 0,
                'leftBottom': 0,
                'rightTop': '100%',
                'rightBottom': '100%',
            }
            const editPos = posValue.split(',').map(pos => pos.trim());
            const width = target.clientWidth;
            const height = target.clientHeight;

            // 起点: 左下の点 (0, elementHeight)
            // 上端（y = 0）に到達するための移動距離 d
            const d = height / Math.cos(angleRad);

            // x 座標の変位: d * sin(10°) = elementHeight * tan(10°)
            const offsetX = height * Math.tan(angleRad);
            editPos.forEach((pos, index) => {
                // pos が setPos のキーに存在するかチェック
                if (Object.prototype.hasOwnProperty.call(setPos, pos)) {
                    // キー名に "left" が含まれている場合の処理
                    if (pos.includes('left')) {
                        setPos[pos] = offsetX + 'px'
                    }
                    // キー名に "right" が含まれている場合の処理
                    else if (pos.includes('right')) {
                        setPos[pos] = `calc(100% - ${offsetX}px)`;
                    }
                }
            });

            target.style.clipPath = `polygon(${setPos['leftTop']} 0, ${setPos['rightTop']} 0, ${setPos['rightBottom']} 100%, ${setPos['leftBottom']} 100%)`;
        })
    }
}

window.addEventListener('DOMContentLoaded', ClipPath);

// ウィンドウリサイズ時にも適用
window.addEventListener('resize', ClipPath);